<div class="ui modal BettingSlip_System_Modal" id="BettingSlip_System_Modal">

    <div style="padding: 2px;" class="header"><span style="font-size:13px;text-transform: uppercase;">{{"Please_select_one_or_more_combinations" | t}}</span></div>

    <div class="content" style="padding: 0.5rem;overflow: scroll; height: 700px;min-height: 700px;">
        <div class="row">
            <div class="ui grid">
              <ng-container *ngFor="let systemSlip of this.tournamentsService.systemSlips; let i = index">
                <div class="eight wide column" [ngStyle]="{'display': (systemSlip.combination > 330)  ? 'none' : 'block'}">
                  <button name="systemslipitem" value="{{this.tournamentsService.isClicked[i] == true ? '1':'0'}}" style="padding: 10px;height:50px;border: 1px solid #bfb8b8 !important;" class="ui fluid button" [ngClass]="{'SystemItemActiveButton':this.tournamentsService.isClicked[i]}" (click)="BettingSlip_System_Button_Click(i)">
                    <span>{{"System" | t}}</span> <span id="systemspanid+{{i}}">{{i+1}}/{{this.tournamentsService.systemSlips.length}}</span>  <span> ({{ systemSlip.combination | number : '1.0-0'}}   {{ "Bets" | t}})</span>
                  </button>
                </div>
              </ng-container>

            </div>
        </div>
    </div>
    <div class="content" style="padding: 0.5rem;">
        <button class="ui fluid button terminalButton" (click)="BettingSlip_System_Button_Ok()" style="height:50px">
            <span>{{ "Ok" | t}}</span>
        </button>
    </div>

</div>
